// Dependencies imports
import React, { useState, useEffect, useRef } from "react";
// Local imports
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
// Styles imports
import assessStyle from "./PopupAssesment.module.scss";
import Add from './AddScore.module.scss';
import Done from "../../../../assets/svgjs/Done";
import Reject from "../../../../assets/svgjs/Reject";
import { useSelector, useDispatch } from "react-redux";
import { awsSignIn, authData } from "../../../../redux/auth/authSlice";
// import config from "../../config/aws-exports";
import config from "../../../../config/aws-exports"
import { API, Auth } from "aws-amplify";
import {
  List,
  ListItem,
  ListItemIcon,
  TextareaAutosize,
  Typography,
  FormGroup,
  Checkbox,
  FormControlLabel,
  FormControl,
  Grid,
  Modal,
  Button,
  Box,
} from "@material-ui/core";
import { Constants } from "../../../../config/constants";
const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: 700,
      backgroundColor: "transparent",
      padding: 0,
      height: "auto",
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "none",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
    },
    root: {
      width: "100%",
      backgroundColor: "transparent",
      "& .MuiBox-root": {
        margin: "-7px",
        padding: "8px",
        backgroundColor: "white",
      },
    },
  }));
const CoursePopAssesment = (props) => {
  let { handleClose,assesmentData } = props;
    const [modalStyle] = React.useState(getModalStyle);
    const [openAnswer, setOpenAnswer] = useState(false);
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [assessAns, setAssessAns] = useState({});
  const [imgUrl, setImgUrl] = useState("");
  const [formatCurDate, setFormatCurDate] = useState(0);
  const [assessmentData, setAssessmentData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
 
  const [score, setScore] = useState("");
  // const [assessAns, setAssessAns] = useState({});
  const dispatch = useDispatch();
  const classes = useStyles();
  let userDetails = useSelector(authData);
  // console.log("row" + JSON.stringify(assesmentData));
  console.log("udata"+JSON.stringify(userDetails));
    
  useEffect(() => {
    getAssessmentData(userDetails);
    formatDate();
    let sdata = { ...userDetails };
   
    dispatch(awsSignIn(sdata));
  }, []);
  async function getAssessmentData(userDetails) {
    setIsLoading(true);
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        assessid: userDetails.btid,
        quiztype: "assess",
        quizid: assesmentData.assessid,
        type: "assessmentdetails",
       
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    
    try {
    
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_ASSESMENT,
        bodyParam
      );
      const { assessment } = response;
    
      console.log("response"+JSON.stringify(response));
      setAssessmentData(assessment);
      setAssessAns(response);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  }
    function getModalStyle() {
        const top = 50;
        const left = 50;
    
        return {
          top: `${top}%`,
          left: `${left}%`,
          transform: `translate(-${top}%, -${left}%)`,
        };
    }
    function viewAns() {
        if (
          assessAns.response !== undefined &&
          assessAns.response.response !== undefined
        ) {
          let l = assessAns.response.response.length;
          let questionsA = assessAns.qitems.length;
          if (l >= questionsA) {
            if (
              assessAns.response.response[currentQuestion].iid ===
              assessAns.qitems[currentQuestion].iid
            ) {
              return assessAns.qitems[currentQuestion].iopts[
                assessAns.response.response[currentQuestion].response
              ].content;
            } else {
              return <div style={{ color: "red" }}> You have not answerd </div>;
            }
          } else {
            return <div style={{ color: "red" }}> You have not answerd </div>;
          }
        } else {
          return <div style={{ color: "red" }}> You have not answerd </div>;
        }
    }
    function answerPrev() {
        console.log("curr", currentQuestion);
        const prevQuestion = currentQuestion - 1;
    
        setCurrentQuestion(prevQuestion);
      }
    
      function answerNext() {
        // console.log("curr", currentQuestion);
        const nextQuestion = currentQuestion + 1;
        if (nextQuestion < assessAns.qitems.length) {
          setCurrentQuestion(nextQuestion);
        }
        console.log("curr", currentQuestion);
  }
  function formatDate() {
    //let some = toTimestamp(moment().format('YYYY-MM-DD h:mm:ss a'));
    setInterval(() => {
      setFormatCurDate(toTimestamp(moment().format("YYYY-MM-DD h:mm:ss a")));
    }, 2000);

    /* console.log(currentDate);
  let res = currentDate.split("-");
      if(res[1] != 0){
        res[1] = res[1] - 1;
      }
  let d = new Date(res[0], res[1], res[2]);
  setFormatCurDate(d.getTime());
  console.log("d",formatCurDate);
  console.log("date",moment(formatCurDate).format("DD/MM/YYYY  h:mm:ss a")) */
  }
  function toTimestamp(strDate) {
    var datum = Date.parse(strDate);
    return datum / 1;
  }
  function handleChange(e) {
    setScore(e.target.value);
  }
  async function gradeAssesment(score) {
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        // eid: usetData.eid,
        bpid: userDetails.curprgcou.bpid,
        assessid: userDetails.asses.btid,
        // quizid: quizId,
        score:score,
        quiztype: "assess",
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
  
    try {
    
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_UPDATE_ASSESMENT_REPORT,
        bodyParam
      );
      const { assessment } = response;
      console.log("response"+JSON.stringify(response));
      handleClose();
    } catch (error) {
      console.error(error);
    }
  }
    return (
        <div className={Add.mainpopup}>
            <p onClick={handleClose}>X</p>
            {/* <h3 >Add Score</h3>
            <button >Submit</button> */}
             <div style={modalStyle} className={classes.paper}>
            <div className={assessStyle.bodyAns}>
              {/*  <pre style={{ color: "white" }}>
                {quizQuestion === undefined || quizQuestion.length === 0 ? (
                  <p>p </p>
                ) : quizQuestion.istem === undefined ? null : (
                  <pre>
                    {console.log("ll", quizQuestion[currentQuestion].istem)}
                  </pre>
                )}
              </pre> */}
              {assessAns.qitems === undefined ||
              assessAns.qitems.length === 0 ? (
                <div style={{ fontSize: "15px" }}>Loading.. </div>
              ) : isLoading == false ? (
                <div>
                  <div className={assessStyle.questionsection}>
                    <div
                      style={{
                        fontWeight: "bold",
                        float: "right",
                        fontSize: "14px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setOpenAnswer(false);
                        setCurrentQuestion(0);

                        setAssessAns([]);
                      }}
                    >
                      {" "}
                      {/* X{" "} */}
                      <p onClick={handleClose}>X</p>
                    </div>
                 
                    <div className={assessStyle.questioncount}>
                      <span>Question {currentQuestion + 1}</span>/
                      {assessAns.qitems.length}
                    </div>
                    <div className={assessStyle.questiontext}>
                      {assessAns.qitems[currentQuestion].istem}
                      {assessAns.qitems[currentQuestion].img ? (
                        <div className="img_container">
                          <img
                            src={`${imgUrl}${assessAns.qitems[currentQuestion].img}`}
                            alt="item"
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className={assessStyle.answersection}>
                    <div
                      className={"btn-group " + assessStyle.btngroupvertical}
                    >
                      {assessAns.qitems[currentQuestion].iopts.map(
                        (answerOption, index, arrayobj) => (
                          <>
                            <div style={{}}>
                              <div>
                                {/* <input
                                  type="radio"
                                  className="btn-check"
                                  name="options"
                                  id={answerOption.content}
                                /> */}
                                <div style={{ display: "flex" }}>
                                  <label
                                    className={
                                      assessStyle.labelstyleAns +
                                      " " +
                                      assessStyle.buttonQuizAns
                                    }
                                    for={answerOption.content}
                                  >
                                    {answerOption.content}
                                  </label>
                                  <span>
                                    {answerOption.correct === "true" ? (
                                      <Done
                                        className="right_size"
                                        cls1="cls1_D"
                                        cls2="cls2_D"
                                      />
                                    ) : (
                                      <Reject
                                        className="Wrong_size"
                                        cls1="cls1_D"
                                        cls2="cls2_D"
                                      />
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </>
                        )
                      )}
                    </div>
                  </div>
                  <br />

                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      display: "flex",
                    }}
                  >
                    {/* Your Answer :{" "}
                    <div style={{ fontSize: "14px", fontWeight: "700" }}>
                      {
                        viewAns()

                        
                      }
                    </div> */}
                  </div>
                  {currentQuestion > 0 ? (
                    <Button
                      color="primary"
                      variant="contained"
                      className="btn-size"
                      onClick={() => answerPrev()}
                      style={{ fontSize: "12px" }}
                    >
                      Prev
                    </Button>
                  ) : null}
                  {currentQuestion + 1 === assessAns.qitems.length ? (
                    <div></div>
                  ) : (
                    <Button
                      color="primary"
                      variant="contained"
                      className="btn-siz"
                      onClick={() => answerNext()}
                      style={{ float: "right", fontSize: "12px" }}
                    >
                      Next
                    </Button>
                  )}
                </div>
              ) : (
                <div>
                  <div
                    style={{
                      fontWeight: "bold",
                      float: "right",
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setOpenAnswer(false);
                      setCurrentQuestion(0);
                      setAssessAns([]);
                    }}
                  >
                    {" "}
                    X{" "}
                  </div>
                  <div style={{}}>
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: "18px",
                      }}
                    >
                      {" "}
                      No Answers
                    </p>
                    </div>
                   
                </div>
            )}
           
          </div>
          
        </div>
        
        </div>
    );
};

export default CoursePopAssesment;